var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"products"},[_c('Header',{attrs:{"store":_vm.store}}),_c('div',{staticClass:"page_content",domProps:{"innerHTML":_vm._s(_vm.page.content)}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }